import React from 'react'
import styles from './styles.module.css'
import useStore from '../../../../BusinessStore/Store'
import uploadIcon from '../../../../../img/uploadSVG.svg'

function GenericCasesBusiness () {
  const {
    isQueryLoading,
    setCountry,
    setRequiredFields,
    setRawCategory,
    setReviews,
    setGeoLocationBusiness
  } = useStore()

  const onClickRealEstateBusinessesValue = () => {
    if (isQueryLoading) return
    setCountry('US')
    setRawCategory('real estate')
    setRequiredFields(['address', 'emailsAndPhonesException'])
  }
  const onClickHighlyRatedRestaurants = () => {
    if (isQueryLoading) return
    setCountry('US')
    setRawCategory('restaurants')
    setReviews(5)
  }
  const onClickSBanksInAustin = () => {
    if (isQueryLoading) return
    setGeoLocationBusiness('-97.7430600,30.2671500,10,mi')
    setCountry('US')
    setRequiredFields(['address'])
    setRawCategory('banking')
  }

  return (
    <section>
      <div className={styles.businessCategoriesContainer}>
        <h2 className={styles.businessCategoriesTitle}>
          More specific examples
        </h2>
        <div className={styles.businessCategoriesValues}>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickRealEstateBusinessesValue}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>
                Realtor groups
              </span>
              <p className={styles.businessCategoriesText}>
                Real estate businesses with email or phone numbers
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickHighlyRatedRestaurants}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>
                {' '}
                Highly-rated restaurants
              </span>
              <p className={styles.businessCategoriesText}>
                Restaurants with 5 star reviews
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickSBanksInAustin}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>
                Banks (Austin, Texas)
              </span>
              <p className={styles.businessCategoriesText}>
                Banks within 10 mile radius of Austin, Tx
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default GenericCasesBusiness
